import { Fragment, useCallback, useEffect, useRef, useState } from "react";

import Grid from '@material-ui/core/Grid';

import Title from '@base/Title';
import Toast from '@base/Toast';
import Loading from "@base/Loading/Loading";
import Divisor from "@base/Divisor/Divisor";

import AjudaService from '@services/AjudaService';

import Ajuda from './Ajuda';

export const ListagemAjuda = () => {
  const [loading, setLoading] = useState(true);

  const [list, setList] = useState([]);

  const toastRef = useRef(null);

  const pageName = 'Gerenciar Textos de Ajuda';

  const carregarDados = useCallback(() => {
    setLoading(true);

    AjudaService.listar().then(resultado => {
        setList(resultado.data);
        setLoading(false);
      })
      .catch(() => toastRef.current.show("error", "Ocorreu um Problema ao Buscar Textos!"));
  }, []);

  useEffect(() => carregarDados(), [carregarDados]);

  return (
    <>
      <Toast ref={toastRef} />
      <Title>{pageName}</Title>

      {loading ?
        <Loading />
      :
        <Grid container spacing={1} style={{ marginTop: 32 }}>
            <Grid item sm={12} lg={12}>
            {list.map((ajuda) => 
              <Fragment key={ajuda.id} >
                <Ajuda ajuda={ajuda} toast={toastRef} />
                <Divisor />
              </Fragment>
            )}
          </Grid>
        </Grid>
      }
    </>
  );
}

export default ListagemAjuda;
